/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import validUrl from 'valid-url';

import { UtmParams } from 'types';
import { parse } from '@tock/query-string';
import AppSettings from 'settings/AppSettings';
import env from '@tock/shared/utils/env';

export function isValid(url: any) {
  return validUrl.isWebUri(url);
}

export function urlIsForDomain(url: any, domain: any) {
  const link = document.createElement('a');
  link.href = url;
  return link.hostname.endsWith(domain);
}

export function urlIsValidAndOnDomain(url: any, domain: any) {
  return isValid(url) && urlIsForDomain(url, domain);
}

export function removeQueryParams(url: string) {
  return url.split('?')[0];
}

export function getConsumerURL(apiBase: string, businessDomain: string) {
  if (window.location.hostname === 'localhost') {
    return `http://localhost:7001/${businessDomain}`;
  }
  const environment = env.get(apiBase);
  const prefix = environment === '' ? 'www' : environment;
  return `https://${prefix}.exploretock.com/${businessDomain}`;
}

export function getJceBaseURL(apiBase: string) {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:5173';
  }
  const environment = env.get(apiBase);
  if (environment === '') {
    return 'https://www.resy.com';
  }

  return 'https://jce-web.e1.resy.com';
}

export function getBaseConsumerURL() {
  if (window.location.hostname === 'localhost') {
    return `http://localhost:7001`;
  }
  const environment = env.get(AppSettings.API_BASE);
  const prefix = environment === '' ? 'www' : environment;
  return `https://${prefix}.exploretock.com`;
}

export function getUtmParams(searchString: string): UtmParams {
  const queryParams = parse(searchString);
  return {
    utmSource: queryParams.utm_source,
    utmMedium: queryParams.utm_medium,
    utmCampaign: queryParams.utm_campaign,
  };
}

// Used to join a base that may or may not have
// a trailing '/' with a relative path that begins
// with a leading '/'. This will prevent paths
// with double slashes ('//').
export function joinPath(base: string, path: string): string {
  return base.charAt(base.length - 1) === '/' ? base.slice(0, -1) + path : base + path;
}
